import { Box, Autocomplete, Button, Grid, Grid2, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, AppBar, Tabs, styled, Tab, Badge } from "@mui/material";
import TokenError from '../tokenError';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import stopMarker from '../../assets/images/stopsMarker.svg';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import { Label } from "flowbite-react";
import { GoogleMap, DrawingManager, Marker, Polyline, Polygon, useJsApiLoader, LoadScript } from "@react-google-maps/api";
import threeDots from '../../assets/images/threeDots.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import { CSVLink } from "react-csv";
import importArrowIcon from '../../assets/images/importArrow.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";

function a11yProps(index){
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    marginRight: theme.spacing(1),
    width:'15%',
    marginTop:'4px',
    marginBottom:'4px',
    color: '#83888E',
    '&.Mui-selected': {
      color: '#fff',
      borderRadius: '4px 4px 0 0',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
}));


const TabWithBadge = ({ label, count, isActive }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ color: isActive ? '#fff' : '#83888E', marginRight:'12px' }}>{label}</Typography>
      <Badge
        badgeContent={count}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#4B4F58',
            color: '#fff',
            borderRadius: '50%',
            minWidth: '22px',
            height: '22px',
            fontSize: '12px',
            fontWeight: 500,
          },
        }}
      />
    </Box>
);

const Address = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const location = useLocation();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [locationId, setLocationId] = useState('');
    const [locationName, setLocationName] = useState('');
    const [locationAddress, setLocationAddress] = useState('');
    const [open, setOpen] = useState(false);
    const [locationLat, setLocationLat] = useState('');
    const [locationLng, setLocationLng] = useState(0);
    const [addressError, setAddressError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [addressTypeTab, setAddressTypeTab] = useState(0);
    const [addressType, setAddressType] = useState('1');
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const rowData = location.state?.rowData;
    const [selectedRow, setSelectedRow] = useState(null);
    const [center, setCenter] = useState({
        lat: 28.644800, lng: 77.216721
    });
    const [isMapClickEnabled, setIsMapClickEnabled] = useState(false);
    const [mapClickSnackbar, setMapClickSnackbar] = useState(false);
    const[AddressSize,setAddressSize] = useState('');
    const map_search_zone = localStorage.getItem('map_search_zone');
    const toggleButtonRef = useRef(null);


    const inputRef = useRef(null);
    const mapRef = useRef(null);
    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '500px',
    };
    
    // Use the same loading approach and ID as other components
    const { isLoaded, loadError } = useGoogleMapsLoader();

    const handleMapClick = (event) => {
        if (!isMapClickEnabled) {
            return; // Ignore clicks if feature is disabled
        }
        if (!window.google || !window.google.maps) {
            console.error('Google Maps API is not loaded.');
            return;
        }
    
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setLocationLat(lat);
        setLocationLng(lng);    
        if (mapRef.current) {
            mapRef.current.setZoom(10);
        }
    
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    setLocationAddress(results[0].formatted_address);
                    setMapClickSnackbar(true);
                } else {
                    console.log('No results found');
                }
            } else {
                console.log('Geocoder failed due to: ' + status);
            }
        });
    };

    const toggleMapClick = () => {
        setIsMapClickEnabled((prev) => !prev);
        setMapClickSnackbar(true);
        setMessage(`Map click selection ${!isMapClickEnabled ? 'enabled' : 'disabled'}`);
    };

    const fetchAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/customer/fetch_specific_address';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                user_id: rowData.user_id,
                address_type: Number(addressTypeTab)+1,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                setSelectedRow(null);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchAddress();
    },[addressTypeTab])

    const handleClose = () => {
        setEditMode(false);
        setOpen(false);
    }

    useEffect(() => {
        const loadAutocomplete = () => {
            if (!window.google || !window.google.maps || !window.google.maps.places) {
                console.error('Google Maps API is not loaded.');
                return;
            }
    
            const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                ...(map_search_zone ? { componentRestrictions: { country: map_search_zone || 'IN' } } : {})
            });
            
            const handlePlaceChanged = () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    const lat = place.geometry.location.lat();
                    const lng = place.geometry.location.lng();
                    setLocationAddress(place.formatted_address || '');
                    setLocationLat(lat);
                    setLocationLng(lng);
                    setCenter({ lat, lng });
    
                    if (mapRef.current) {
                        mapRef.current.setCenter({ lat, lng });
                        mapRef.current.setZoom(15);
                    }
                }
            };
    
            autocomplete.addListener('place_changed', handlePlaceChanged);
    
            // Cleanup function
            return () => {
                window.google.maps.event.removeListener(autocomplete, 'place_changed');
            };
        };
    
        if (AddressSize > 2) {
            loadAutocomplete();
        }
    }, [open, editMode, AddressSize]);
    

    useEffect(() => {
        if (inputRef.current) {
            setAddressSize(inputRef.current.value.length);
        }
    }, [inputRef.current?.value]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false);
    };

    useEffect(() => {
        if (isLoaded && mapRef.current && toggleButtonRef.current) {
            mapRef.current.controls[window.google.maps.ControlPosition.TOP_LEFT].clear();
            mapRef.current.controls[window.google.maps.ControlPosition.TOP_LEFT].push(toggleButtonRef.current);
        }
    }, [isLoaded, open]);

    const handleOpen = () => {
        setOpen(true);
        setAddressError(false);
        setIsMapClickEnabled(false);
        setNameError(false);
        setLocationId('');
        setLocationName('');
        setLocationAddress('');
        setLocationLng('');
        setLocationLat('');
        const city = cities.find((cityObj) => cityObj.city_id === cityFilter);
        if (city?.center_latitude && city?.center_longitude) {
            const geocenter = {
                lat: Number(city?.center_latitude),
                lng: Number(city?.center_longitude)
            };
            setCenter(geocenter);
        }
    }

    const handleOpenEditLocation = (row) => {
        console.log('Opening edit modal with raw data:', row);
        setEditMode(true);
        setIsMapClickEnabled(false);
        setAddressError(false);
        setNameError(false);
        setOpen(true);
        setLocationId(row.id);
        setLocationName(row.address_name);
        setLocationAddress(row.address);
        
        const lat = Number(row?.latitude || 0);
        const lng = Number(row?.longitude || 0);
        setLocationLat(lat);
        setLocationLng(lng);
        
        // Update center if valid coordinates are available
        if (lat && lng) {
            setCenter({ lat, lng });
        }
    }

    const handleAllyProps = (event, newValue) => {
        setAddressTypeTab(newValue);
    };

    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        
        let hasError = false;
        
        if(locationName==''){
            setNameError(true); // Set error state to trigger red styling
            showSnackbar(true);
            setMessage('Please enter the location name.');
            hasError = true;
        } else {
            setNameError(false);
        }
        
        if(locationAddress==''){
            setAddressError(true); // Set error state to trigger red styling
            if (!hasError) {
                showSnackbar(true);
                setMessage('Please enter the address.');
            }
            hasError = true;
        } else {
            setAddressError(false);
        }
            
        if (hasError) {
            return;
        }
            
        const payload = {
            token: token,
            user_id: rowData.user_id,
            address_name: locationName,
            address: locationAddress,
            latitude: locationLat,
            longitude: locationLng,
            address_type: addressType,
        };
        if(editMode && locationId!=''){
            payload.id = locationId;
        }

        try {
            const url = operationsUrl + '/panel/customer/add_update_address';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

                setOpen(false);
                setEditMode(false);
                fetchAddress();

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const deletingAddress = (row) => {
        setOpenDeleteConfirmModal(true);
        setSelectedRow(row);
    }

    const handleDeleteAddress = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = operationsUrl + '/panel/customer/add_update_address';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                user_id: selectedRow.user_id,
                // timestamp: timestamp,
                address_name: selectedRow.address_name,
                address: selectedRow.address,
                latitude: selectedRow.latitude,
                longitude: selectedRow.longitude,
                address_type: selectedRow.address_type,
                id: selectedRow.id,
                is_active: 0,
            };
            const response = await makePostRequestToUrl(url,body);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchAddress();
                setOpenDeleteConfirmModal(false);
                setSelectedRow(null);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while deleting document:', error);
            setMessage(error);
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Address
            </Typography>


            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                {/* <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2> */}
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpen}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Address
                    </Button>
                </Grid2>
            </Grid2>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop:'2%'}}>
                <AppBar position="static" color="default" elevation={0} sx={{backgroundColor:'#2A313C', borderRadius:'12px 12px 0 0'}}>
                    <Tabs
                    value={addressTypeTab}
                    onChange={handleAllyProps}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="booking tabs"
                    sx={{
                        '& .MuiTabs-indicator': {
                            height: '3px',
                            width: '100%'
                        }
                    }}
                    >
                    <StyledTab label={<TabWithBadge label="Pickup Address" isActive={addressTypeTab === 0} />} {...a11yProps(0)} />
                    <StyledTab label={<TabWithBadge label="Drop Address" isActive={addressTypeTab === 1} />} {...a11yProps(1)} />
                    </Tabs>
                </AppBar>

                <TableContainer className="table-container" sx={{ marginTop: '0px', maxHeight:'62vh' }}>
                    <Table stickyHeader className="scrollable-table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Location ID</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Location Name</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Address</TableCell>
                                <TableCell align="center" className="table-header" style={{ width: '15%' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.length === 0 && (
                                <TableRow>
                                <TableCell colSpan={24} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                                </TableRow>
                            )}
                            {rows.map((row) => {

                                return(
                                    <TableRow key={row.tms_client_id}>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.address_name}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.address}</Typography></TableCell>
                                        <TableCell align="center">
                                            <Button
                                                variant="contained"
                                                onClick={() => handleOpenEditLocation(row)}
                                                sx={{
                                                    backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                    borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                    '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                    '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                }}>
                                                
                                                <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                    <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                </svg>
                                            </Button>

                                            <Button
                                                variant="contained"
                                                onClick={() => deletingAddress(row)}
                                                sx={{
                                                    backgroundColor: '#fff', color: '#D14545', border: '1px solid #D14545', textTransform: 'none',
                                                    borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px", marginLeft:'2%',
                                                    '&:hover': {backgroundColor: '#D14545', color: 'white'},
                                                    '&:active': { backgroundColor: '#D14545', color: 'white'}
                                                }}>
                                                
                                                <Typography sx={{marginRight:'6%'}}>Delete</Typography>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: open ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleClose} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {editMode ? 'Edit Location' : 'Add Location'}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Select Address Type<span style={{ color: 'red' }}>*</span></Label>
                                    <Select
                                        value={addressType}
                                        onChange={(e) => setAddressType(e.target.value)}
                                        style={{ width:'100%',height: '50px', borderRadius: '8px', backgroundColor:'#FFFFFF', marginTop:'1%'}}
                                    >
                                        <MenuItem value="1">Pickup Address</MenuItem>
                                        <MenuItem value="2">Drop Address</MenuItem>
                                        <MenuItem value="3">Both</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Location Name<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}} placeholder="Enter Location Name" fullWidth variant="outlined"
                                        value={locationName} 
                                        onChange={(e) => {
                                            setLocationName(e.target.value);
                                            // Clear error state when user starts typing
                                            if (nameError && e.target.value !== '') {
                                                setNameError(false);
                                            }
                                        }} 
                                        type="text"
                                        // Add error prop for MUI's built-in error styling
                                        error={nameError}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                                // Custom border color for consistency with the address field
                                                border: nameError ? '1px solid red' : ''
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Location Address<span style={{ color: 'red' }}>*</span></Label>
                                    {/* <TextField sx={{marginTop:'1%'}} placeholder="Location Address" fullWidth variant="outlined" type="text"
                                        value={locationAddress} onChange={(e) => setLocationAddress(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    /> */}
                                    <input ref={inputRef} type="text" placeholder=" Search Location" className="filterBtn"
                                        style={{
                                            width:'94%', marginTop:'2%',
                                            backgroundPosition: '8px center',
                                            border: addressError ? '1px solid red' : '',
                                        }}
                                        value={locationAddress}
                                        onChange={(e) => {
                                            setLocationAddress(e.target.value);
                                            // Clear error state when user starts typing
                                            if (addressError && e.target.value !== '') {
                                                setAddressError(false);
                                            }
                                        }}
                                    />
                                </Grid>

                            </Grid>

                            <Grid2 item sx={{marginTop:'2%'}}>
                                <>
                                    {/* Simplified geofence implementation based on Geofence.jsx */}
                                    <div className="relative">
                                        {isLoaded ? (
                                            <div style={{ width: '100%', height: '500px', position: 'relative' }}>
                                                <div
                                            ref={toggleButtonRef}
                                            style={{
                                                backgroundColor: isMapClickEnabled ? '#4CAF50' : '#FFFFFF',
                                                border: '1px solid #DADCE0',
                                                borderRadius: '2px',
                                                boxShadow: '0 1px 2px #acacac',
                                                cursor: 'pointer',
                                                margin: '10px 0px',
                                                padding: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '22px',
                                                height: '22px',
                                            }}
                                            onClick={toggleMapClick}
                                            title={isMapClickEnabled ? 'Disable map click selection' : 'Enable map click selection'}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"
                                                    fill={isMapClickEnabled ? '#FFFFFF' : '#acacac'}
                                                />
                                            </svg>
                                        </div>
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    zoom={10}
                                                    center={center}
                                                    options={{
                                                        disableDefaultUI: false,
                                                        zoomControl: true
                                                    }}
                                                    onLoad={(map) => {
                                                        console.log('Map loaded, setting ref');
                                                        mapRef.current = map;
                                                        
                                                        // If we have coordinates, make sure to fit the map to show the marker
                                                        if (locationLat && locationLng) {
                                                            const position = {lat: Number(locationLat), lng: Number(locationLng)};
                                                            map.setCenter(position);
                                                            map.setZoom(15); // Zoom in closer to see the marker clearly
                                                        }
                                                    }}
                                                    onClick={handleMapClick}
                                                >
                                                    {/* Only show marker if we have valid coordinates */}
                                                    {locationLat && locationLng && (
                                                        <Marker
                                                            position={{lat: Number(locationLat), lng: Number(locationLng)}}
                                                            animation={window.google?.maps?.Animation?.DROP}
                                                        />
                                                    )}
                                                </GoogleMap>
                                            </div>
                                        ) : (
                                            <div style={{padding: '20px', textAlign: 'center'}}>Loading Google Maps...</div>
                                        )}
                                    </div>

                                </>

                            </Grid2>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '30px' }}>
                                <Button variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                        backgroundColor: '#0065FF',color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>

            <Dialog
                open={openDeleteConfirmModal}
                onClose={() => setOpenDeleteConfirmModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                        Are you sure you want to delete this address permanently?
                        <br/> This cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenDeleteConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleDeleteAddress();
                            // setOpenDeleteConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={2000} 
                onClose={handleSnackbarClose} 
                message={message}
            />
        </div>
    );
}

export default Address;